import React from 'react'
import BackToHome from '../../components/back-to-home'
import bg1 from '../../assets/images/authentication.jpg'

export default function PageForgotPassword2() {
  return (
    <>
     <BackToHome/> 

        <section className="bg-home d-flex align-items-center" style={{backgroundPosition:'center', backgroundImage:`url(${bg1})`}}>
            <div className="bg-overlay bg-overlay-primary"></div>
            <div className="container">
                <div className="row justify-content-center">
                    <div className="col-lg-5 col-md-7">
                        <div className="login_page bg-white rounded p-4">
                            <div className="text-center">
                                <h4 className="mb-3">Recovery Password</h4>  
                            </div>
                            <form className="login-form">
                                <div className="row">
                                    <div className="col-lg-12">
                                        <p className="text-muted">Please enter your email address. You will receive a link to create a new password via email.</p>
                                        <div className="mb-3">
                                            <label className="form-label">Email address <span className="text-danger">*</span></label>
                                            <input type="email" className="form-control" placeholder="Email" name="email" required=""/>
                                        </div>
                                    </div>
                                    <div className="col-lg-12">
                                        <div className="d-grid">
                                            <button className="btn btn-primary">Send</button>
                                        </div>
                                    </div>
                                </div>
                            </form>
                        </div>
                    </div> 
                </div>
            </div>
        </section>
    </>
  )
}
